<template>
  <div class="toggle-wrap">
    <label class="toggle-text" v-if="textType" :class="[textType,{on:this.checked}]"></label>
    <input type="checkbox" class="set-switch" :checked="checked" @change="onChange" />
  </div>
</template>

<script>
export default {
  name: "UiToggle",
  props:['checked','textType'],
  methods:{
    onChange () {
      this.$emit('setYn', this.checked)
    }
  }
};
</script>

<style scoped>
.set-switch-wrap {
  display: flex;
  border-bottom: solid 1px #ddd;
  padding-bottom: 7px;
  padding-top: 7px;
}
input[type="checkbox"].set-switch {
  display: inline-block;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  outline: 0;
  cursor: pointer;
  width: 40px;
  height: 20px;
  border-radius: 3em;
  background-color: #f0f0f0;
  transition: background-color 0.15s ease-in-out;
  position: relative;
  margin-right: 15px;
  max-width: 40px;
}

.set-switch:after {
  /* margin-left: 2px; */
  position: absolute;
  /* display: block; */
  content: "";
  left: 0;
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 100%;
  top: 50%;
  transform: translateY(-50%);
  transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;
  box-shadow: 2px 1px 5px 0px rgb(0 0 0 / 41%);
}
input[type="checkbox"].set-switch:checked {
  background: #18698b;
}
input[type="checkbox"].set-switch:checked:after {
  left: calc(100% - 18px);
}
.set-switch-text {
  font-weight: 400;
  color: #cc1010;
  /* transition: .5s; */
}
input[type="checkbox"].set-switch:checked + .set-switch-text {
  font-weight: 800;
  color: #23af23;
}

.toggle-wrap {
  display: flex;
  width: 100%;
  align-items: center;
  padding: 4px;
  box-sizing: border-box;
}
.toggle-wrap.dp-inb {
  display:inline-block;
}
.toggle-text {
  text-align: center;
  font-weight: 800;
  color: #ca1717;
  width: 50px;
}
.toggle-text.on{
  color: #0c960c;
}
.toggle-text.default.on:after {
  content: "ON";
}
.toggle-text.default:after {
  content: "OFF";
}
.toggle-text.auto.on:after {
  content: "자동";
}
.toggle-text.auto:after {
  content: "수동";
}
.items .toggle-text {
  display: none;
}
</style>
